import {FC} from 'react'
import {ListLoading} from '../ListLoading'
import {FieldProps} from '../Form'
import dayjs from 'dayjs'
import {fileSrc} from '../fileUtils'

type Props = {
  isLoading: boolean
  data: any
  fields: FieldProps[] | ((options: {values: any}) => FieldProps[])
}

export const CView: FC<Props> = (props: Props) => {
  const fields =
    typeof props.fields === 'function' ? props.fields({values: props.data || {}}) : props.fields

  const getValue = (path: string, fieldObject?: any) =>
    path
      ?.split('.')
      .reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : null),
        fieldObject || props.data
      )

  return (
    <>
      <div className='flex flex-col overflow-y-auto pr-7' id='kt_modal_add_academic_year_scroll' />

      <div className='flex flex-wrap -mx-2'>
        {fields.map((field, index) =>
          field.view !== false ? (
            <div className={`mb-5 px-2 ${field.full ? 'w-full' : 'w-full lg:w-1/2'}`} key={index}>
              <div className='flex flex-wrap'>
                <label className={`font-semibold text-gray-500 ${field.full ? 'w-1/6' : 'w-1/3'}`}>
                  {field.label}
                </label>
                <div className={`${field.full ? 'w-5/6' : 'w-2/3'}`}>
                  {field.type === 'switch' ? (
                    <span
                      className={`capitalize inline-block rounded px-2 py-1 text-white text-xs font-medium ${
                        getValue(field.viewName || field.name) ? 'bg-green-500' : 'bg-red-500'
                      }`}
                    >
                      {getValue(field.viewName || field.name) === true
                        ? field.truthValue || getValue(field.viewName || field.name)?.toString()
                        : field.falseValue || getValue(field.viewName || field.name)?.toString()}
                    </span>
                  ) : field.type === 'content' && getValue(field.viewName || field.name) ? (
                    <div
                      className='prose max-w-none'
                      dangerouslySetInnerHTML={{__html: getValue(field.viewName || field.name)}}
                    />
                  ) : field.type === 'files' && getValue(field.viewName || field.name) ? (
                    <a
                      href={fileSrc(getValue(field.viewName || field.name))}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-teal-600 font-semibold text-base'
                    >
                      View File
                    </a>
                  ) : (field.type as string) === 'key-value' && getValue(field.viewName || field.name) ? (
                    (() => {
                      let value = getValue(field.viewName || field.name)
                      if (typeof value === 'string') {
                        try {
                          value = JSON.parse(value)
                        } catch (e) {
                          return <span className='font-semibold text-base text-gray-800'>{value}</span>
                        }
                      }
                      
                      if (typeof value !== 'object' || value === null) {
                        return <span className='font-semibold text-base text-gray-800'>{String(value)}</span>
                      }

                      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

                      return (
                        <div className='flex flex-col gap-2 w-full'>
                          {Object.entries(value)
                            .filter(([k]) => !uuidRegex.test(k))
                            .map(([k, v]) => (
                            <div key={k} className='bg-gray-50 p-3 rounded-md border border-gray-100'>
                              <span className='block text-xs text-gray-500 mb-1 font-semibold uppercase tracking-wider'>{k}</span>
                              <span className='block text-sm text-gray-800 font-medium'>{typeof v === 'boolean' ? (v ? 'Yes' : 'No') : String(v)}</span>
                            </div>
                          ))}
                        </div>
                      )
                    })()
                  ) : field.type === 'link' && getValue(field.viewName || field.name) ? (
                    <a
                      href={fileSrc(getValue(field.viewName || field.name))}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-teal-600 font-semibold text-base'
                    >
                      Open <i className='fa-solid fa-up-right-from-square text-teal-600'></i>
                    </a>
                  ) : field.type === 'image' && getValue(field.viewName || field.name) ? (
                    <img
                      src={fileSrc(getValue(field.viewName || field.name))}
                      className='w-full h-full'
                      alt={field.label}
                    />
                  ) : (
                    <span className='font-semibold text-base text-gray-800'>
                      {field.type === 'date' && getValue(field.viewName || field.name)
                        ? dayjs(getValue(field.viewName || field.name)).format('ll')
                        : getValue(field.viewName || field.name)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ) : null
        )}
      </div>

      {props.isLoading && <ListLoading />}
    </>
  )
}
